import { Box, CircularProgress, Typography } from '@mui/material';
import { type FC } from 'react';
import { MdRefresh } from 'react-icons/md';

export type StreamOverlayStatus = 'initializing' | 'reconnecting' | 'error';

interface StreamStatusOverlayProps {
  status: StreamOverlayStatus;
  errorMessage?: string;
}

const STATUS_LABELS: Record<StreamOverlayStatus, string> = {
  initializing: 'Starting stream…',
  reconnecting: 'Reconnecting…',
  error: 'Camera connection lost',
};

const StreamStatusOverlay: FC<StreamStatusOverlayProps> = ({ status, errorMessage }) => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      zIndex: 6,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      px: 2,
      backgroundColor: 'rgba(0, 0, 0, 0.55)',
      color: 'white',
      textAlign: 'center',
      pointerEvents: 'none',
    }}
  >
    {status === 'error' ? (
      <>
        <MdRefresh size={32} />
        <Typography variant="body2">{errorMessage ?? STATUS_LABELS.error}</Typography>
        <Typography variant="caption">Retrying automatically — click to retry sooner</Typography>
      </>
    ) : (
      <>
        <CircularProgress color="inherit" size={28} />
        <Typography variant="body2">{STATUS_LABELS[status]}</Typography>
      </>
    )}
  </Box>
);

export default StreamStatusOverlay;
